import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import AdDiv from './AdDiv';
import CtnAdDiv from './CtnAdDiv';
import AdStaticDiv from './AdStaticDiv';
import { findJarvisAdCode, ADTYPE } from './jarvisutil';
import { addToQueue, loadAllAdsFromQueue } from './redux';
import { checkJarvisIsAdActive } from './utils';

class AdCaller extends React.Component {
  constructor(props) {
    super(props);
    this.adData = {};
  }
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    loadAllAdsFromQueue: PropTypes.func.isRequired,
    lazyload: PropTypes.bool,
    isPrime: PropTypes.bool.isRequired,
    deviceType: PropTypes.string,
    isCTN: PropTypes.bool,
    navigation: PropTypes.shape({}),
    pauseAdCall: PropTypes.bool,
  };
  static defaultProps = {
    lazyload: false,
    deviceType: '',
    isCTN: false,
    navigation: {},
    pauseAdCall: false,
  };
  shouldComponentUpdate() {
    if (this.props.isNewGam) {
      return false;
    }
    if (this.props.skipReRender) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    if (this.props.immediateLoad) {
      this.props.loadAllAdsFromQueue('');
    }
    if (this.props.delay) {
      setTimeout(() => {
        this.props.loadAllAdsFromQueue('');
      }, this.props.delay);
    }
  }

  componentDidUpdate(prevProps) {
    const path =
      (this.props.navigation &&
        this.props.navigation.data &&
        this.props.navigation.data.path) ||
      '';
    if (prevProps.pauseAdCall && !this.props.pauseAdCall) {
      setTimeout(() => {
        this.props.loadAllAdsFromQueue('', path);
      }, 500);
    }
  }

  caimpaignBasedAdsHandling = data => {
    const { caimpagnAds } = this.props;
    if (
      data &&
      data.checkJarvisPerpectual &&
      data.articleIndex &&
      data.articleIndex > 1
    ) {
      const caimAdName = data.checkJarvisPerpectual;
      const currentCaimp = _get(caimpagnAds, `${caimAdName}`);
      let isActive = _get(currentCaimp, `isAdActive`);
      if (checkJarvisIsAdActive(data.checkJarvisPerpectual)) {
        isActive = 1;
      }
      return isActive === 1 && currentCaimp?.reverse ? 0 : isActive;
    }
    return 1;
  };

  renderADDivs(data) {
    const { props } = this;
    const { adType } = data;
    switch (adType) {
      case ADTYPE.TABOOLA:
        return <AdStaticDiv {...data} />;
      case ADTYPE.CTN:
        return <CtnAdDiv {...props} data={{ ...data }} />;
      default:
        return (
          <AdDiv
            {...this.props}
            data={{ ...data }}
            deviceType={this.props.deviceType}
          />
        );
    }
  }

  render() {
    if (this.props.pauseAdCall) {
      return false;
    }
    const {
      lazyload,
      isPrime,
      byPassIsPrime,
      revenueAds,
      msid,
      isCTN,
    } = this.props;

    let { data = {}, adWapperClass, inPlaceholder } = this.props;
    const jarvisad = findJarvisAdCode({
      data,
      isCTN,
      revenueAds,
      msid,
    });
    if (jarvisad) {
      data = jarvisad;
    }
    if (data.jdisabled) {
      return null;
    }

    if (isCTN) {
      data.adType = ADTYPE.CTN;
    }
    if (lazyload) {
      data.lazyLoad = 1;
    }
    adWapperClass = data.adWapperClass || adWapperClass;
    inPlaceholder = data.inPlaceholder || inPlaceholder;
    const isClassActive = this.caimpaignBasedAdsHandling(data);
    if (isClassActive === 0) {
      adWapperClass = '';
    }
    if (data?.overrideWapper) {
      adWapperClass = data?.overrideWapper;
    }

    if ((!isPrime || byPassIsPrime) && typeof data !== 'undefined') {
      if (adWapperClass) {
        return (
          <div className={adWapperClass}>
            {this.renderADDivs(data)}
            {inPlaceholder && <div className={inPlaceholder} />}
          </div>
        );
      }
      return this.renderADDivs(data);
    }
    return null;
  }
}

AdCaller.propTypes = {
  byPassIsPrime: PropTypes.bool,
  revenueAds: PropTypes.shape({}),
  dataset: PropTypes.shape({}),
  adWapperClass: PropTypes.string,
  inPlaceholder: PropTypes.string,
  msid: PropTypes.string,
  isNewGam: PropTypes.bool,
  skipReRender: PropTypes.bool,
  immediateLoad: PropTypes.bool,
  caimpagnAds: PropTypes.shape({}),
  delay: PropTypes.number,
};

AdCaller.defaultProps = {
  byPassIsPrime: false,
  revenueAds: null,
  dataset: {},
  adWapperClass: '',
  inPlaceholder: '',
  msid: '',
  isNewGam: false,
  skipReRender: false,
  immediateLoad: false,
  caimpagnAds: {},
  delay: 0,
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  navigation: state.navigation,
  adsCounter: _get(state, 'adCaller.adsCounter'),
  adsQueueData: state.adCaller.adsQueueData,
  revenueAds: _get(state, 'revenue.data.ads', null),
  isNewGam: _get(state, 'revenue.data.widgets.isNewGam', false),
  caimpagnAds: _get(state, 'common.siteConfig.revenue', {}),
});

const mapDispatchToProps = dispatch => ({
  addToQueue: params => {
    dispatch(addToQueue(params));
  },
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdCaller);
